'use strict';

jQuery(document).ready(function ($) {

    window.REMODAL_GLOBALS = {
        NAMESPACE: 'modal',
        DEFAULTS: {
            hashTracking: false
        }
    };

    $('#trigger-bug-report').on('click', function (e) {
        e.preventDefault();
        jQuery('#LR-bug-modal').remodal().open();
    });

    $('#LR-report-bug').on('submit', function (e) {
        e.preventDefault();
        captchaWidgetId = $('#bug-report-captcha > div > textarea').attr("id").slice(-1);

        if (isNaN(captchaWidgetId)) {
            captchaWidgetId = 0;
        }
        captcha = grecaptcha.getResponse(captchaWidgetId);

        var data = new FormData();
        //prep the data

        data.append('action', 'bugreport');
        data.append('text', $('#bug-report').val());
        data.append('email', $('#bug-email').val());
        data.append('platform', navigator.platform);
        data.append('useragent', navigator.userAgent);
        data.append('vendor', navigator.vendor);
        data.append('url', window.location.href);
        data.append('screenres', window.screen.availWidth + "x" + window.screen.availHeight);
        data.append('windowsize', window.innerWidth + "x" + window.innerHeight);
        data.append('captcha', captcha);
        data.append('bug-screenshot', $('#bug-screenshot')[0].files[0]);

        $('.preloader').show();
        $.ajax({
            url: ajax_object.ajaxurl,
            type: 'post',
            contentType: false,
            cache: false,
            processData: false,
            data: data,

            success: function success(result) {
                if (!result.success) {
                    $('.errors').text(result.data.error).show();
                    $('#LR-report-bug textarea').addClass('error');
                    $('.bug-report-loader').hide();
                } else {
                    $('.bug-report-loader').hide();
                    $('#bug-form').hide();
                    $('#confirmed').show();
                }
            },

            error: function error(result) {}
        });
    });
});

function getScreenshot() {
    html2canvas(document.html, { background: '#fff', useCORS: true }).then(function (canvas) {
        screenshot = canvas.toDataURL('image/png');
    });
}